import React from 'react';
import PropTypes from 'prop-types';
import Box from "@mui/material/Box";
import DisplayPriorityRangeSlider from "../../common/range-slider/DisplayPriorityRangeSlider";
import ModernPriorityRangeSlider from "../../common/range-slider/ModernPriorityRangeSlider";
import { getIntlTranslation } from "../../../../utils/helper";

function MultiplePriority(props) {
  const { data, onChange, useModern = false } = props;
  
  // Use modern slider for new form, original slider for old form
  const SliderComponent = useModern ? ModernPriorityRangeSlider : DisplayPriorityRangeSlider;
  
  return (
    <>
      <Box>
        {/* Labels for old form (original slider) */}
        {!useModern && (
          <div className="grid-container" style={{ width:"100%"}}>
            <span className="grid-item shortTerm">
              {getIntlTranslation("_Short-Term")} (%)
            </span>
            <span className="grid-item mediumTerm">
              {getIntlTranslation("_Medium-Term")} (%)
            </span>
            <span className="grid-item longTerm">
              {" "}
              {getIntlTranslation("_Long-Term")} (%)
            </span>
          </div>
        )}
        
        {/* Slider component */}
        <Box sx={{ width: '100%', py: useModern ? 1 : 0 }}>
          <SliderComponent data={data} onChange={onChange} />
        </Box>
      </Box>
    </>
  );
}

MultiplePriority.propTypes = {
    data: PropTypes.array,
    onChange: PropTypes.func,
    useModern: PropTypes.bool,
}

export default MultiplePriority
